import { isSiteRegionCode } from '~/utils/societePayloadBuilder/regions';
import type { PayloadValidationResult } from '~/utils/societePayloadBuilder/types';
import { validateRequiredString } from '~/utils/societePayloadBuilder/validationHelpers';

import { validateCtaLink, validateOptionalExpiresAt } from '../payloadFields';

import type { LuxPlusPromoBanner, LuxPlusPromoBannerCarouselState } from './types';

export type LuxPlusPromoBannerCarouselValidationResult = PayloadValidationResult;

function validationLabel(sectionLabel: string, fieldLabel: string): string {
  return `${sectionLabel} ${fieldLabel}`;
}

function validateEligibleRegions(regions: Array<string>, label: string, errors: Array<string>) {
  if (regions.length === 0) {
    errors.push(`${validationLabel(label, 'Eligible Regions')} requires at least one region`);
    return;
  }

  const invalidRegions = regions.filter((region) => !isSiteRegionCode(region));
  if (invalidRegions.length > 0) {
    errors.push(`${validationLabel(label, 'Eligible Regions')} has invalid codes: ${invalidRegions.join(', ')}`);
  }
}

function validatePromo(promo: LuxPlusPromoBanner, errors: Array<string>) {
  const label = promo.draftLabel;
  validateRequiredString(promo.label, validationLabel(label, 'Label'), errors);
  validateRequiredString(promo.title, validationLabel(label, 'Title'), errors);
  validateRequiredString(promo.ctaText, validationLabel(label, 'CTA text'), errors);
  validateCtaLink(promo.ctaLink, validationLabel(label, 'CTA URL'), errors);
  validateEligibleRegions(promo.eligibleRegions, label, errors);
  validateOptionalExpiresAt(promo.expiresAt, validationLabel(label, 'Expires at'), errors);
}

export function validatePromoBannerCarouselPayload(
  state: LuxPlusPromoBannerCarouselState,
): LuxPlusPromoBannerCarouselValidationResult {
  const errors: Array<string> = [];

  if (state.promos.length === 0) {
    errors.push('Promo banners requires at least one promo');
  }

  state.promos.forEach((promo) => validatePromo(promo, errors));

  return {
    isValid: errors.length === 0,
    errors,
  };
}
